module.exports = __webpack_public_path__ + "static/img/20231128_03.21deab4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2023/20231128_03.png
// module id = Ab1x
// module chunks = 0